module.exports = __webpack_public_path__ + "img/google_icon.f6ce5696.svg";